import {
  RE_ENTRY_COST,
  RE_ENTRY_COST_REV,
  RE_ENTRY_ASAP,
  RE_ENTRY_ASAP_REV,
  RE_ENTRY_WT_ASAP,
  RE_ENTRY_WT_ASAP_REV,
  COMBINED_PERCENT,
} from '@quantiply/common/constants';

import { createNumberOptions } from './helpers/numbers';
import { createStrikeLevels } from './helpers/strike-levels';
import { createAtmPercentageLevels } from './helpers/atm-percentage-levels';
import { createStraddlePercentageRange } from './helpers/straddle-percentage-range';

export const levels = createStrikeLevels({ itm: 10, otm: 25 });
export const atmPercentageLevels = createAtmPercentageLevels({
  itm: 10,
  otm: 10,
});
export const straddlePercentageRange = createStraddlePercentageRange({
  limit: 60,
});

export const typeSymbols = {
  COMBINED_POINT: 'pts',
  COMBINED_PERCENT: '%',
  TOTAL_AMOUNT: '₹',
  PER_POSITION_PERCENT: '%',
  PER_POSITION_POINT: 'pts',
  none: ' ',
};

export const symbolGroupColors = [
  '#33cdff',
  '#66db34',
  '#bd72ff',
  '#fb901e',
  '#ff4947',
];

export const reEntryMaxNoEntriesOptionsMax = 20;

export const reEntryMaxNoEntriesOptions = [
  {
    label: 'No max limit',
    value: 0,
  },
  ...createNumberOptions(1, reEntryMaxNoEntriesOptionsMax),
];

export const tableRentryOptions = [
  {
    label: 'RE COST',
    value: RE_ENTRY_COST,
    extendedLabel: 'Re-enter at cost (RE COST)',
  },
  {
    label: 'RE COST REVERSE',
    value: RE_ENTRY_COST_REV,
    extendedLabel: 'Reverse positions & re-enter at cost (RE COST REVERSE)',
  },
  {
    label: 'RE ASAP',
    value: RE_ENTRY_ASAP,
    extendedLabel: 'Re-enter asap (RE ASAP)',
  },
  {
    label: 'RE ASAP REVERSE',
    value: RE_ENTRY_ASAP_REV,
    extendedLabel: 'Reverse positions & re-enter asap (RE ASAP REVERSE)',
  },
  {
    label: 'RE W&T',
    value: RE_ENTRY_WT_ASAP,
    extendedLabel: 'Re-entry with wait & trade (RE W&T)',
  },
  {
    label: 'RE W&T REVERSE',
    value: RE_ENTRY_WT_ASAP_REV,
    extendedLabel:
      'Re-entry with wait & trade and reverse positions (RE W&T REVERSE)',
  },
  {
    label: 'RE: None',
    value: 'none',
    extendedLabel: 'Re-enter: None',
  },
];

export const profitLockAndSlTrailingDefaults = {
  trailingStoploss: {
    type: COMBINED_PERCENT,
    moveBy: 0,
    trailBy: 0,
  },
  lockProfit: {
    type: COMBINED_PERCENT,
    reachedTo: 0,
    lockAt: 0,
  },
  trailProfit: {
    type: COMBINED_PERCENT,
    moveBy: 0,
    trailBy: 0,
  },
  lockTrailProfit: {
    type: COMBINED_PERCENT,
    reachedTo: 0,
    lockAt: 0,
    moveBy: 0,
    trailBy: 0,
  },
};
